import React from 'react';

import { Route, Routes } from 'react-router-dom';

import { CampaignDetailsList } from './pages/list';
import { CampaignDetailsManage } from './pages/manage';

export const CampaignDetails: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<CampaignDetailsList />} />
      <Route path="/create" element={<CampaignDetailsManage />} />
      <Route path="/:id" element={<CampaignDetailsManage />} />
    </Routes>
  );
};
